import { LicenseConfiguration, LicensePrices, LicenseValue } from "../Models/License";
import { User } from "../Models/Models";
import RespondClient from "../Models/RespondClient";
import { getApiHost } from "../util";
import { getInstance } from "./InstanceProvider";

export default class SubscriptionProvider {
    public subscriptionProvider: SubscriptionProvider | undefined;
    public getInstance() {
        if (!this.subscriptionProvider) {
            this.subscriptionProvider = new SubscriptionProvider();
        }

        return this.subscriptionProvider;
    }

    public getList(): Promise<RespondClient<LicenseValue[]>> {
        return getInstance().get(`${getApiHost()}/license/list`);
    }

    public getPrice(conf: LicenseConfiguration): Promise<RespondClient<LicensePrices>> {
        return getInstance().post(`${getApiHost()}/license/price-usd`, conf);
    }

    public onUpdate(conf: LicenseConfiguration): Promise<RespondClient<number>> {
        return getInstance().post(`${getApiHost()}/license`, conf);
    }

    public getSeats(): Promise<RespondClient<User[]>> {
        return getInstance().get(`${getApiHost()}/license/seats`);
    }

    public applyId(id: string): Promise<RespondClient<string>> {
        return getInstance().post(`${getApiHost()}/license/id`, { key: id });
    }

    public applyTrial(): Promise<RespondClient<string>> {
        return getInstance().post(`${getApiHost()}/license/trial`);
    }

    public assign(id: string): Promise<RespondClient<string>> {
        return getInstance().post(`${getApiHost()}/license/assignments`, { userId: id });
    }

    public unassign(id: string): Promise<RespondClient<string>> {
        return getInstance().delete(`${getApiHost()}/license/assignments/${id}`);
    }

    public search(search: string): Promise<RespondClient<User[]>> {
        return getInstance().get(`${getApiHost()}/license/search?search=${search}`);
    }

    public cancel(): Promise<RespondClient<string>> {
        return getInstance().delete(`${getApiHost()}/license`);
    }
}

export const SubscriptionProviderInstance = new SubscriptionProvider();
